import React from 'react';
import { Link } from 'react-router-dom';
import { Ruler, AlertTriangle } from 'lucide-react';

export const SizingGuide = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="sizing-guide-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="sizing-title">Sizing & Fit Guide</h1>
          <p className="text-lg text-softgrey">Vintage sizing differs from modern sizing.</p>
        </div>

        <div className="space-y-10">
          <section className="bg-coral/10 border-2 border-coral/30 p-8 rounded-xl" data-testid="sizing-notice">
            <div className="flex items-center gap-3 mb-3">
              <AlertTriangle className="w-6 h-6 text-coral" />
              <h2 className="text-xl font-heading font-bold">Important Notice</h2>
            </div>
            <p className="text-softgrey leading-relaxed">Vintage sizing differs significantly from modern sizing. A "Medium" from the 1980s may not fit the same as a modern "Medium". Always refer to the measurements provided on each listing.</p>
          </section>

          <section className="bg-cream p-8 rounded-xl" data-testid="measurements-section">
            <div className="flex items-center gap-3 mb-4">
              <Ruler className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Each Item Includes</h2>
            </div>
            <ul className="list-disc list-inside space-y-3 text-softgrey ml-2">
              <li><strong>Chest / Bust</strong> - measured flat across the chest</li>
              <li><strong>Length</strong> - measured from shoulder to hem</li>
              <li><strong>Waist</strong> - measured at the narrowest point</li>
            </ul>
          </section>

          <section data-testid="compare-section">
            <h2 className="text-2xl font-heading font-bold mb-4">How to Get the Best Fit</h2>
            <p className="text-softgrey leading-relaxed mb-4">Compare with your own garments. We recommend laying a similar item you own flat and measuring it, then comparing those measurements with the ones listed on our product page.</p>
            <ol className="list-decimal list-inside space-y-2 text-softgrey ml-2">
              <li>Lay your item flat on a surface</li>
              <li>Measure across the chest from armpit to armpit</li>
              <li>Measure length from shoulder seam to bottom hem</li>
              <li>Compare with product measurements listed</li>
            </ol>
          </section>

          <section data-testid="help-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Need Help?</h2>
            <p className="text-softgrey leading-relaxed">If you're unsure about sizing, please contact us before purchasing - we're happy to help!</p>
            <Link to="/contact" className="inline-block mt-4 text-coral hover:underline font-semibold">Contact Us →</Link>
          </section>
        </div>
      </div>
    </div>
  );
};
